module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/75dfdd77f40989c76f8be89442c48f57.png";